import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

function renderOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isGrouped = options.some(function (opt) {
    return opt.options;
  });

  if (isGrouped) {
    return options.map(function (group) {
      return /*#__PURE__*/React.createElement("optgroup", {
        key: group.label,
        label: group.label
      }, group.options.map(function (option) {
        return /*#__PURE__*/React.createElement("option", {
          key: "".concat(option.label, "_").concat(option.value),
          value: option.value,
          disabled: Boolean(option.disabled)
        }, option.label);
      }));
    });
  }

  return options.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      key: option.key || option.value,
      value: option.value,
      disabled: option.disabled
    }, option.separator ? '──' : option.label);
  });
}

function Select(_ref) {
  var inverse = _ref.inverse,
      monotone = _ref.monotone,
      error = _ref.error,
      hideBorder = _ref.hideBorder,
      classNames = _ref.classNames,
      options = _ref.options,
      id = _ref.id,
      size = _ref.size,
      placeholder = _ref.placeholder,
      defaultValue = _ref.defaultValue,
      otherProps = _objectWithoutProperties(_ref, ["inverse", "monotone", "error", "hideBorder", "classNames", "options", "id", "size", "placeholder", "defaultValue"]);

  var cssClass = classnames({
    'tds-select': true,
    'tds-select--inverse': inverse,
    'tds-select--monotone': monotone,
    'tds-select--has-error': error,
    'tds-select--no-border': hideBorder,
    'tds-select--sm': size === 'sm',
    'tds-select--lg': size === 'lg'
  }, classNames);
  var noValueDefined = typeof otherProps.value === 'undefined';

  var selectedValue = _objectSpread({}, noValueDefined ? {
    defaultValue: defaultValue
  } : {});

  return /*#__PURE__*/React.createElement("select", _extends({
    id: id,
    className: cssClass
  }, otherProps, selectedValue), placeholder && /*#__PURE__*/React.createElement("option", {
    key: "placeholder-no-value",
    value: "",
    disabled: true
  }, placeholder), renderOptions(options));
}

Select.displayName = "Select";
var option = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool
}); // Props used in SelectGroup

Select.propTypes = {
  id: PropTypes.string,
  classNames: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  inverse: PropTypes.bool,
  monotone: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.oneOfType([option, PropTypes.shape({
    label: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(option).isRequired
  })])).isRequired,
  error: PropTypes.bool,
  hideBorder: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg', 'md']),
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string
};
Select.defaultProps = {
  id: undefined,
  classNames: '',
  inverse: false,
  monotone: false,
  error: false,
  hideBorder: false,
  size: 'md',
  placeholder: undefined,
  defaultValue: ''
};
export default Select;